export const AQUA_DRAFTS_BASE_URL = "https://aqua-drafts.web.app";
export const API_BASE_URL =
  "https://kintoneconnect-qdbwxdfcvq-an.a.run.app/api";
